import { execute } from '../../command';
import { CharStruct, DrawContext, DrawPlugin } from '../../type/common.interface';
import { ColorBorderPlugin } from './plugins/border/color-border-plugin';
import { ColorFillPlugin } from './plugins/fill/color-fill-plugin';

const plugins: DrawPlugin[] = [new ColorBorderPlugin(), new ColorFillPlugin()];

export function drawChar(context: DrawContext<CharStruct>) {
    context.canvasContext.save();
    plugins.forEach(plugin => (plugin as DrawPlugin).before?.(context));
    execute(context.canvasContext, context.struct.cmds); // 绘制文字路径
    plugins.forEach(plugin => (plugin as DrawPlugin).after?.(context));
    context.canvasContext.restore();
}
